import util from '@/libs/util.js'
import {
    AccountLogin
} from '@api/sys.login'
import {
    createImg,
    getLoginUser,
    loginout
} from '@/api/sys.login'
import qs from 'qs'
export default {
    namespaced: true,
    actions: {
        /**
                             * 获取验证码
                             */
        createImg() {
            return createImg()
        },
        /**
                             * @description 登录
                             * @param {Object} param context
                             * @param {Object} param vm {Object} vue 实例
                             * @param {Object} param j_username {String} 用户账号
                             * @param {Object} param j_password {String} 密码
                             * @param {Object} param authCode {String} 验证码
                             * @param {Object} param route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
                             */
        login({
            dispatch
        }, {
            vm,
            jUserName,
            jPassword,
            authCode,
            authCodeKey
        }) {
            // 开始请求登录接口
            // 开始请求登录接口
            let postData = qs.stringify({
                login: jUserName,
                password: jPassword,
                captcha: authCode,
                key: authCodeKey
            })

            // var postData = {}
            // postData.j_username = jUserName
            // postData.j_password = jPassword
            // postData.authCode = authCode
            // await dispatch(
            //   'd2admin/user/set', {
            //     name: "asd"
            //   }, {
            //     root: true
            //   }
            // )
            AccountLogin(postData)
                .then(res => {
                    if (res.data.status_code == 422) {
                        vm.loading.close()
                        vm.$message({
                            message: res.data.message,
                            type: 'error',
                            duration: 5 * 1000
                        })

                        vm.newAuthCode()
                        return
                    }

                    if (res.data && res.data.result === 0) {
                        vm.$message({
                            message: res.data.message,
                            type: 'error',
                            duration: 5 * 1000
                        })
                        return
                    } else {
                        util.cookies.set('token', res.data.token_type + ' ' + res.data.token)
                    }

                    getLoginUser().then(async res => {
                        if (res.data.data.state == '2') {
                            vm.loading.close()
                            vm.$message({
                                message: '该账户已冻结，不能登录',
                                type: 'error',
                                duration: 5 * 1000
                            })
                            return
                        }
                        if (res.data.data.zi_org_id && res.data.data.zi_org_state == '2') {
                            vm.loading.close()
                            vm.$message({
                                message: '子机构已冻结，不能登录',
                                type: 'error',
                                duration: 5 * 1000
                            })
                            return
                        }
                        if (res.data.data.fu_org_id && res.data.data.fu_org_state == '2') {
                            vm.loading.close()
                            vm.$message({
                                message: '机构已冻结，不能登录',
                                type: 'error',
                                duration: 5 * 1000
                            })
                            return
                        }
                        localStorage.setItem('userInfo', JSON.stringify(res.data.data))

                        await dispatch(
                            'd2admin/user/set', {
                            name: res.data.data.nick_name
                        }, {
                            root: true
                        }
                        )
                        vm.closeAll(vm)
                        vm.loading.close()
                        vm.$router.push('/index')
                    }).catch(err => {
                        vm.loading.close()
                        console.log('err: ', err)
                    })
                })
                .catch(err => {
                    vm.loading.close()
                    console.log('err: ', err)
                })
        },
        /**
                             * @description 注销用户并返回登录页面
                             * @param {Object} param context
                             * @param {Object} param vm {Object} vue 实例
                             * @param {Object} param confirm {Boolean} 是否需要确认
                             */
        logout({
            commit
        }, {
            vm,
            confirm = false
        }) {
            /**
                                           * @description 注销
                                           */
            function logout() {
                const centerId = JSON.parse(localStorage.getItem('userInfo')).center_id
                if (centerId) {
                    loginout({ login: centerId })
                }
                document.cookie.split(';').forEach(function (cookie) {
                    document.cookie = cookie
                        .replace(/^ +/, '')
                        .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/')
                })
                // 删除cookie
                util.cookies.remove('token')
                util.cookies.remove('uuid')
                util.cookies.remove('userInfo')
                vm.closeAll(vm)
                // 跳转路由
                vm.$router.push({
                    name: 'login'
                })
            }
            // 判断是否需要确认
            if (confirm) {
                commit('d2admin/gray/set', true, {
                    root: true
                })
                vm.$confirm(
                    '注销当前账户吗?  打开的标签页和用户设置将会被保存。',
                    '确认操作', {
                    confirmButtonText: '确定注销',
                    cancelButtonText: '放弃',
                    type: 'warning'
                }
                )
                    .then(() => {
                        commit('d2admin/gray/set', false, {
                            root: true
                        })
                        logout()
                    })
                    .catch(() => {
                        commit('d2admin/gray/set', false, {
                            root: true
                        })
                        vm.$message('放弃注销用户')
                    })
            } else {
                logout()
            }
        },
        /**
                             * @description 用户登录后从持久化数据加载一系列的设置
                             * @param {Object} state vuex state
                             */
        load({
            commit,
            dispatch
        }) {
            return new Promise(async resolve => {
                // DB -> store 加载用户名
                await dispatch('d2admin/user/load', null, {
                    root: true
                })
                // DB -> store 加载主题
                await dispatch('d2admin/theme/load', null, {
                    root: true
                })
                // DB -> store 加载页面过渡效果设置
                await dispatch('d2admin/transition/load', null, {
                    root: true
                })
                // DB -> store 持久化数据加载上次退出时的多页列表
                await dispatch('d2admin/page/openedLoad', null, {
                    root: true
                })
                // DB -> store 持久化数据加载侧边栏折叠状态
                await dispatch('d2admin/menu/asideCollapseLoad', null, {
                    root: true
                })
                // DB -> store 持久化数据加载全局尺寸
                await dispatch('d2admin/size/load', null, {
                    root: true
                })
                // end
                resolve()
            })
        },
        importf({
            dispatch
        }, {
            vm,
            data

        }) {
            importf(data)
                .then(res => {
                    return res
                })
                .catch(err => {
                    console.log('err: ', err)
                })
        }
    }
}
